import React from 'react';

const LoadingSpinner = ({ 
  height = 80, 
  width = 80, 
  color = "#ff6b35",
  visible = true 
}) => {
  if (!visible) return null;

  return (
    <div className="loading-spinner" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      height: `${height}px`,
      width: `${width}px`,
      margin: '0 auto'
    }}>
      <div 
        className="spinner-circle"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          border: `6px solid #e0e0e0`,
          borderTop: `6px solid ${color}`,
          borderRight: `6px solid ${color}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          background: 'transparent'
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
